/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Titleend1Inputs */

const ja_careers_titleend1 = /** @type {(inputs: Careers_Titleend1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AT PLAYBRAIN`)
};

const en_careers_titleend1 = /** @type {(inputs: Careers_Titleend1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AT PLAYBRAIN`)
};

/**
* | output |
* | --- |
* | "AT PLAYBRAIN" |
*
* @param {Careers_Titleend1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const careers_titleend1 = /** @type {((inputs?: Careers_Titleend1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Titleend1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_titleend1(inputs)
	return en_careers_titleend1(inputs)
});
export { careers_titleend1 as "careers_titleEnd" }